import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { Invitation } from "@core/features/invitation";

type Args = {
  organizationId: number;
  enabled?: boolean;
};

/**
 * Fetch all active invitations for an organization.
 * Includes both participant and orgAdmin invitation types.
 */
export function useFetchOrganizationInvitations({
  organizationId,
  enabled = true,
}: Args) {
  return useQuery<Invitation[]>({
    queryKey: ["organization", organizationId, "invitations"],
    queryFn: async () => {
      return await apiRequest(
        `/organization/${organizationId}/invitations/`,
        "GET"
      );
    },
    enabled: enabled && !!organizationId,
  });
}
